module.exports = __webpack_public_path__ + "img/gal-3.ba13e783.jpg";